<template>
  <section class="section container">
    <div class="container mt-0 mb-6">
      <h1 class="title is-4 mb-3 is-pulled-right">
        {{ $t("online store module settings") }}
      </h1>
    </div>

    <div class="columns mt-5">
      <div class="column">
        <h1 class="title is-5">{{ $t("general") }}</h1>
        <div class="field">
          <input
            class="is-checkradio"
            type="checkbox"
            id="chk_is_active"
            name="chk_is_active"
            v-model="meta.is_active"
          />
          <label for="chk_is_active">{{ $t("is active") }}</label>
        </div>
        <div class="message is-warning" v-show="!meta.is_active">
          <div class="message-body">
            <strong>{{
              $t(
                "when is not active, the message shown is the one at the end of this configuration."
              )
            }}</strong>
          </div>
        </div>
      </div>
      <div class="column">
        <div class="field">
          <generic-dropdown
            :title="$t('drive module integration')"
            :placeholder="$t('select one')"
            :is_multiple="false"
            url="/drive/catalog"
            name_field="name"
            value_field="drive_id"
            @selected="drive_changed"
            ref="drive_dropdown"
          />
        </div>
      </div>
    </div>

    <div class="columns mt-5">
      <div class="column">
        <div class="field">
          <generic-dropdown
            :title="$t('neonet payment module integration')"
            :placeholder="$t('select one')"
            :is_multiple="false"
            url="/visanet_payment/profile/catalog"
            name_field="name"
            value_field="uuid"
            @selected="visa_profile_changed"
            ref="visa_profile_dropdown"
          />
        </div>
      </div>
      <div class="column">
        <div class="field">
          <generic-dropdown
            :title="$t('default user')"
            :placeholder="$t('select one')"
            :is_multiple="false"
            url="/access/user/catalog"
            name_field="username"
            value_field="user_id"
            @selected="user_changed"
            ref="user_dropdown"
          />
        </div>
      </div>
    </div>

    <div class="field" v-show="!meta.is_active">
      <label class="label">{{ $t("message when inactive") }}</label>
      <vue-monaco-editor
        v-model:value="meta.inactive_message"
        theme="vs-dark"
        language="html"
        :options="{
          automaticLayout: true,
          formatOnType: true,
          formatOnPaste: true,
          tabSize: 2,
          scrollBeyondLastLine: false,
          folding: true,
          bracketPairColorization: true,
          autoClosingBrackets: 'always',
          autoIndent: 'full',
        }"
        style="height: 500px"
      />
    </div>

    <div class="container mt-6">
      <div class="field mt-5">
        <div class="control">
          <button class="button is-rounded is-primary" @click="save">
            <span class="icon"><i class="fa fa-save"></i></span>
            <span>{{ $t("save") }}</span>
          </button>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
import {
  save_configuration,
  get_configuration,
  success_message,
  error_message,
} from "@/utils";
import { isEmpty } from "lodash";
import GenericDropdown from "@/components/generic_dropdown/Index.vue";
import "bulma-extensions/bulma-checkradio/dist/css/bulma-checkradio.min.css";
import { v4 } from "uuid";
import { VueMonacoEditor } from "@guolao/vue-monaco-editor";

export default {
  name: "MuseumSettings",
  components: {
    GenericDropdown,
    VueMonacoEditor,
  },
  data() {
    return {
      meta: {},
    };
  },
  methods: {
    save() {
      let v = this;
      let data = { ...v.meta };
      v.$root.loader(true);
      save_configuration(v, data)
        .then(() => {
          success_message(v.$t("configuration saved"));
        })
        .catch((error) => {
          error_message(error);
        })
        .finally(() => {
          v.$root.loader(false);
        });
    },
    drive_changed(drive) {
      let v = this;
      v.meta.drive_id = drive.drive_id;
    },
    visa_profile_changed(visa_profile) {
      let v = this;
      v.meta.visa_profile = visa_profile.uuid;
    },
    user_changed(user) {
      let v = this;
      v.meta.user_id = user.user_id;
    },
  },
  created() {
    let v = this;
    v.$root.loader(true);
    get_configuration(this)
      .then((conf) => {
        if (conf && !isEmpty(conf)) {
          v.meta = conf;
        }
        if (conf && conf.drive_id)
          v.$refs.drive_dropdown.set_value(conf.drive_id);
        if (conf && conf.visa_profile)
          v.$refs.visa_profile_dropdown.set_value(conf.visa_profile);
        if (conf && conf.user_id) v.$refs.user_dropdown.set_value(conf.user_id);
      })
      .catch((error) => {
        error_message(error);
      })
      .finally(() => {
        v.$root.loader(false);
      });
  },
};
</script>

<style></style>
